import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';

import { Title } from 'src/onboarding/components/typography/Title/Title';

import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const calorieTrackingMethod = useStore((state) => state.calorieTrackingMethod);
  const setCalorieTrackingMethod = useStore((state) => state.setCalorieTrackingMethod);
  const { onNext, onPrev, currentIndex } = useNav();


  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.calorieTrackingMethod.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={calorieTrackingMethod}
          onChange={(value) => {
            setCalorieTrackingMethod(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'calorie-tracking-method',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={"Using an app"}>
            <span>📱</span> {t('onboarding.calorieTrackingMethod.options.app')}
          </Option>
          <Option value={"On a website"}>
            <span>💻</span> {t('onboarding.calorieTrackingMethod.options.website')}
          </Option>
          <Option value={"On paper"}>
            <span>📝</span> {t('onboarding.calorieTrackingMethod.options.paper')}
          </Option>
          <Option value={"In a spreadsheet"}>
            <span>📊</span> {t('onboarding.calorieTrackingMethod.options.spreadsheet')}
          </Option>
          <Option value={"With a calculator"}>
            <span>🔢</span> {t('onboarding.calorieTrackingMethod.options.calculator')}
          </Option>
          <Option value={"In my head"}>
            <span>🤔</span> {t('onboarding.calorieTrackingMethod.options.head')}
          </Option>
          <Option value={"Other"}>
            <span>❓</span> {t('onboarding.calorieTrackingMethod.options.other')}
          </Option>
        </Check>
      </div>
    </div>
  );
}

export default Page;
